import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeHideableValue,
    doppeHideableValueCreateHidden
} from '../../client-server-common/types/doppe-hideable-value';
import {
    BymoTemplateSpeedDialAutoComplete
} from '../../components/bymo-templates/bymo-template-speed-dial/bymo-template-speed-dial-common';
import {DoppeActionTypeContentSpecialSettingsMetadata} from "../../client-server-common";

export namespace DoppeActionTypeSpeedDial {
    export interface ActionSettings {
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete;
        showFullScreenAutoCompleteOnMobile: boolean;
        searchPlaceholder: DoppeHideableValue<string>;
        showActionsInSearch: boolean;
        showLinksInSearch: boolean;
    }
}

export const doppeActionTypeSpeedDial = doppeActionTypeDefineMetadata<DoppeActionTypeSpeedDial.ActionSettings>({
    id: 'io.bymo.action/speed-dial',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        showFullScreenAutoCompleteOnMobile: false,
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete.OnInputSearch,
        searchPlaceholder: doppeHideableValueCreateHidden(''),
        showActionsInSearch: false,
        showLinksInSearch: true,
    }),
    canRenderInPage: true,
    actionSettingsMetadata: {
        contentSettingsMetadata: DoppeActionTypeContentSpecialSettingsMetadata.Ignored,
        supportsActionCtaButtons: false,
        supportsContentSections: false
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false
});